import { render, staticRenderFns } from "./DateSection.vue?vue&type=template&id=96727768&scoped=true"
import script from "./DateSection.vue?vue&type=script&lang=js"
export * from "./DateSection.vue?vue&type=script&lang=js"
import style0 from "./DateSection.vue?vue&type=style&index=0&id=96727768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96727768",
  null
  
)

export default component.exports